import { render, staticRenderFns } from "./order.vue?vue&type=template&id=6e0ab330&scoped=true&"
import script from "./order.vue?vue&type=script&lang=tsx&"
export * from "./order.vue?vue&type=script&lang=tsx&"
import style0 from "./order.vue?vue&type=style&index=0&id=6e0ab330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0ab330",
  null
  
)

export default component.exports